import React from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Grid } from '@mui/material';

import { InfoField } from '@occc-app/design-system';

import { MetaData } from '../redux';
import { DateTimeFormat, formatDateTime } from '../../../../lib/date';

type Props = MetaData & {
  fieldDisabled: (field: string) => boolean;
};

export const MetaDataConfigurationSummary: React.FC<Props> = ({
  expireAt,
  fieldDisabled,
  publishAt,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        {fieldDisabled('publishAtDate') ? (
          <InfoField
            label='Publish At'
            value={publishAt ? formatDateTime(publishAt, DateTimeFormat.DateTime12h) : undefined}
          />
        ) : (
          <DateTimePicker
            value={publishAt}
            label='Publish At'
            disabled={fieldDisabled('publishAtDate')}
            slotProps={{ textField: { name: 'publishAt' } }}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={6}>
        {fieldDisabled('expireAtDate') ? (
          <InfoField
            label='Expire At'
            value={expireAt ? formatDateTime(expireAt, DateTimeFormat.DateTime12h) : undefined}
          />
        ) : (
          <DateTimePicker
            value={expireAt}
            label='Expire At'
            disabled={fieldDisabled('expireAtDate')}
            slotProps={{ textField: { name: 'expireAt' } }}
          />
        )}
      </Grid>
    </Grid>
  );
};
